import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { setAuthHeader } from 'api';
import { LoginPage } from '../pages/Login';
import { DashboardPage } from '../pages/Dashboard';
import { KnowledgesPage } from '../pages/Knowledges';
import { PricesPage } from '../pages/Prices';
import { InstructionPage } from '../pages/Instruction';
import { ConversationsPage } from '../pages/Conversations';
import { RestrictedRoute } from './RestrictedRoute';
import { PrivateRoute } from './PrivateRoute';

export const App = () => {
  const token = useSelector(state => state.admin?.token);

  useEffect(() => {
    if (token) {
      setAuthHeader(token);
    }
  }, [token]);

  return (
    <Routes>
      <Route
        path="/admin/login"
        element={
          <RestrictedRoute
            component={LoginPage}
            redirectTo="/admin/dashboard"
          />
        }
      />
      <Route
        path="/admin/dashboard"
        element={
          <PrivateRoute component={DashboardPage} redirectTo="/admin/login" />
        }
      />
      <Route
        path="/admin/knowledges"
        element={
          <PrivateRoute component={KnowledgesPage} redirectTo="/admin/login" />
        }
      />
      <Route
        path="/admin/prices"
        element={
          <PrivateRoute component={PricesPage} redirectTo="/admin/login" />
        }
      />
      <Route
        path="/admin/instruction"
        element={
          <PrivateRoute component={InstructionPage} redirectTo="/admin/login" />
        }
      />
      <Route
        path="/admin/conversations"
        element={
          <PrivateRoute
            component={ConversationsPage}
            redirectTo="/admin/login"
          />
        }
      />
      <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
    </Routes>
  );
};
